/**
 * 分时资金流向
 */
import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import {checkFootAuth, checkFootTitleAuth} from '../dectorator/checkauthdectorator/index.js';
import {LINE_TYPE} from '../setting.js';
import Util, {mergeModelData, curryFun} from '../../util/index.js';
const model = {
  fundflowData: {
    Type: Array,
    Default: () => ([]),
  }
};
export default class TrendFundflowState extends FootDectorator(BaseContext) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    const {fundflowData} = this.state.data;
    let {maxValue, minValue} = this.calcRange({
      data: fundflowData,
      targetKey: 'value',
      isAdditional: true
    });
    maxValue = Math.max(maxValue, Math.abs(minValue));
    maxValue *= 1.1;
    minValue = -maxValue;
    this.maxValue = maxValue;
    this.minValue = minValue;
  }
  _calcAxis() {
    const {fundflowData} = this.state.data;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: fundflowData});
  }
  _drawMain() {
    const {
      left,
      bottom,
    } = this.availArea;
    const {fundflowData} = this.state.data;
    const {LINE} = LINE_TYPE;
    const {fundflowLine} = this.option.FundFlowDirection;
    this._drawLine(LINE, fundflowData, left, bottom, fundflowLine.lineWidth, fundflowLine.color);
  }
  _drawAxisY() {
    const ctx = this.context;
    const {axisY} = this.option.FundFlowDirection;
    const baseSize = this.state.baseSize;
    const {
      top,
      right,
      bottom
    } = this.availArea;
    const maxValue = this.maxValue;
    const minValue = this.minValue;
    if (!Util.isValidNumber(maxValue)) {
      return;
    }
    const {
      color,
      sizeRatio,
      fontFamily,
    } = axisY;
    ctx.beginPath();
    ctx.fillStyle = color;
    ctx.font = sizeRatio * baseSize * this.dpr + "px " + fontFamily;
    ctx.textAlign = 'right';
    ctx.textBaseline = 'top';
    ctx.fillText(maxValue.toFixed(2), right, top);
    ctx.textBaseline = 'bottom';
    ctx.fillText(minValue.toFixed(2), right, bottom);
  }
  // @checkFootTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const {top} = this.availArea;
    const {fundflowData, current} = this.state.data;
    const {height, baseSize} = this.state;
    const {baseLine} = this.option.FootContext.title;
    const baseLineY = top + height * baseLine;
    const {left} = this.availArea;
    ctx2.beginPath();
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'top';
    const {
      sizeRatio,
      fontFamily,
      color
    } = this.option.FundFlowDirection.topText;
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.fillStyle = color;
    // TODO 资金流数据需等待当前分钟结束后才有数据，会比last_px的数据少
    const len = Math.min(fundflowData.length - 1, current);
    const data = fundflowData[len];
    let text;
    if (Util.isDef(data)) {
      const {value} = data;
      if (Util.isValidNumber(value)) {
        text = '资金流向: ' + value.toFixed(2) + '万元';
      }
    }
    if (!text) {
      text = '资金流向: -万元';
    }
    ctx2.fillText(text, left, baseLineY);
  }
}